<template>
  <div class="sign-in-form">
    <BasePreloader v-if="pendingLoginByToken"/>
    <div class="sign-in-form__content">

      <h2 class="sign-in-form__title"
          v-if="isForCredit">
        {{ $tAuth('for_credit_title') }}
      </h2>
      <h2 class="sign-in-form__title"
          v-else-if="isForLegal">
        {{ $tAuth('title-for-legal') }}
      </h2>
      <h2 class="sign-in-form__title"
          v-else-if="isForRespond">
        {{ $tAuth('title-for-respond') }}
      </h2>
      <h2 class="sign-in-form__title"
          v-else-if="isForBookmarksPage">
        {{ $tAuth('title-for-bookmarks-page') }}
      </h2>
      <h2 class="sign-in-form__title"
          v-else-if="referralCode">
        {{ $tAuth('title-for-referral-code') }}
      </h2>
      <h2 v-else-if="$route.query.phone"
          class="sign-in-form__title">
        {{ $tAuth('title-for-already-authorized') }}
      </h2>
      <h2 v-else-if="$tAuth('Login to the site')"
          class="sign-in-form__title">
        {{ $tAuth('Login to the site') }}
      </h2>

      <div v-if="isForCredit"
           class="sign-in-form__top-text  text">
        <p>{{ $tAuth('for_credit') }}</p>
      </div>
      <div v-else-if="isForLegal"
           class="sign-in-form__top-text  text">
        <p>{{ $tAuth('text-for-legal') }}</p>
      </div>
      <div v-else-if="isForRespond"
           class="sign-in-form__top-text  text">
        <p>{{ $tAuth('text-for-respond') }}</p>
      </div>
      <div v-else-if="isForBookmarksPage"
           class="sign-in-form__top-text  text">
        <p>{{ $tAuth('text-for-bookmarks-page') }}</p>
      </div>
      <div v-else-if="referralCode"
           class="sign-in-form__top-text  text">
        <p>{{ $tAuth('text-for-referral-code') }}</p>
      </div>
      <!--      <div v-else-if="isForMassSent"-->
      <!--           class="sign-in-form__top-text  text">-->
      <!--        <p>{{ $tAuth('for-mass-sent') }}</p>-->
      <!--      </div>-->
      <div v-else-if="$tAuth('text-default')"
           class="sign-in-form__top-text  text">
        <p>{{ $tAuth('text-default') }}</p>
      </div>


      <!--      <div v-if="false" class="sign-in-form__roles-radio radio-list">-->
      <!--        <div class="radio-list__list">-->
      <!--          <button type="button"-->
      <!--                  v-for="item in roles"-->
      <!--                  :key="item.id"-->
      <!--                  :class="inputs.user_type.value === item.id ? '_checked' : null"-->
      <!--                  class="reset-button radio-list__radio checkbox"-->
      <!--                  @click.prevent="onClickRole(item.id)"-->
      <!--          >-->
      <!--            <span class="checkbox__mark"></span>-->
      <!--            <span class="checkbox__text">{{ $tAuth(item.name) }}</span>-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="sign-in-form__group">
        <div class="sign-in-form__row">
          <div class="sign-in-form__col  _col-2  _labels">
            <div class="sign-in-form__col-label">
              {{ $tAuth('Phone number') }}
            </div>
          </div>
          <div class="sign-in-form__col  _col-2  d-xs-none">
          </div>
          <div class="sign-in-form__col  _col-2">
            <BaseInputPhone v-model="inputs.phone.value"
                            :error="$tAuth(inputs.phone.error)"
                            @input="onInput('phone', $event)"
                            @validate="onValidateTel"
                            @keypress.enter.prevent.native="isPhoneSuccessButtonActive ? sendPhone() : null"/>
          </div>
          <div class="sign-in-form__col _col-2">
            <button v-if="isPhoneSuccessButtonActive"
                    type="button"
                    @click.prevent="sendPhone"
                    :class="pendingSendPhone ? '_pending' : null"
                    class="base-btn base-btn--green sign-in-form__col-btn">
              <span v-if="isSent"
                    class="base-btn__text">{{ $tAuth('Send again') }}</span>
              <span v-else
                    class="base-btn__text">{{ $tAuth('Confirm') }}</span>
              <BasePreloader v-if="pendingSendPhone"/>
            </button>
            <button v-else
                    type="button"
                    disabled
                    :class="pendingSendPhone ? '_pending' : null"
                    class="base-btn base-btn--outline-dark sign-in-form__col-btn  _disabled">
              <SignInFormTimer v-if="showTimer"
                               :durationS="timerDurationS"
                               @end="onTimerEnd"
                               class="sign-in-form__phone-timer"/>
              <span v-else-if="isSent"
                    class="base-btn__text">{{ $tAuth('Send again') }}</span>
              <span v-else
                    class="base-btn__text">{{ $tAuth('Confirm') }}</span>
              <BasePreloader v-if="pendingSendPhone"/>
            </button>
          </div>
          <template v-if="isSent">
            <div v-if="message" class="sign-in-form__col  _col-full">
              <BaseAlert :value="message" class="sign-in-form__message  _message"/>
            </div>

            <div class="sign-in-form__col  _col  _labels">
              <div class="sign-in-form__col-label">
                {{ $tAuth('SMS code') }}
              </div>
            </div>
            <div class="sign-in-form__col  _col-btn  d-xs-none">
            </div>

            <div class="sign-in-form__col _col">
              <BaseInput v-model="inputs.code.value"
                         :error="$tAuth(inputs.code.error)"
                         name="sms-code"
                         onautocomplete="off"
                         @keypress.enter.prevent.native="isLoginButtonActive ? onLogin() : null"
                         type="password"
              />
            </div>
            <div class="sign-in-form__col _col-btn">
              <template v-if="isLoginButtonActive">
                <button v-if="isRegister"
                        type="button"
                        @click.prevent="onLogin"
                        :class="pendingLogin ? '_pending' : null"
                        class="base-btn base-btn--green sign-in-form__col-btn  netpeak-register">
                  <span class="base-btn__text">{{ $tAuth('Sign in') }}</span>
                  <BasePreloader v-if="pendingLogin"/>
                </button>
                <button v-else
                        type="button"
                        @click.prevent="onLogin"
                        :class="pendingLogin ? '_pending' : null"
                        class="base-btn base-btn--green sign-in-form__col-btn">
                  <span class="base-btn__text">{{ $tAuth('Sign in') }}</span>
                  <BasePreloader v-if="pendingLogin"/>
                </button>
              </template>
              <button v-else
                      type="button"
                      disabled
                      :class="pendingLogin ? '_pending' : null"
                      class="base-btn base-btn--green sign-in-form__col-btn  _disabled">
                <span class="base-btn__text">{{ $tAuth('Sign in') }}</span>
                <BasePreloader v-if="pendingLogin"/>
              </button>
            </div>
          </template>
        </div>
      </div>

      <BaseCheckbox v-if="!isSent"
                    :checked="agree"
                    @input="onAgreeChange"
                    class="sign-in-form__checkbox"
      >
        <div slot="label"
             class="checkbox__text">
          {{ $tAuth('I agree to the') }}
          <router-link-modified :to="{name:'terms-of-use'}"
                                target="_blank"
                                tag="a"

          >{{ $tAuth('terms of the user agreement') }}
          </router-link-modified>&nbsp;
          {{ $tAuth('and') }}&nbsp;
          <router-link-modified :to="{name:'privacy-policy'}"
                                target="_blank"
                                tag="a"
          >
            {{ $tAuth('privacy policy') }}
          </router-link-modified>
        </div>
      </BaseCheckbox>

      <BaseAlert :value="overallErrorsMix"
                 class="sign-in-form__alert  _error"/>

    </div>
    <!--    <AuthSocials :referralCode="referralCode"-->
    <!--                 class="sign-in-form__content"/>-->
    <div class="sign-in-form__notification-wrap">
      <div class="sign-in-form__notification  inline-notification">
        <div class="inline-notification__title">{{ $tAuth('Problems with authorization?') }}</div>
        <div class="inline-notification__message text">
          <p> {{ $tAuth('Ask us in chat or write on our email') }} <a href="#">support@jobian.com</a></p>
        </div>
      </div>
    </div>

    <div class="sign-in-form__for-employers">
      <div class="sign-in-form__for-employers-row">
        <div class="sign-in-form__for-employers-title">{{ $tAuth('offer_a_job_q') }}</div>
        <router-link-modified
          class="base-btn base-btn--blue sign-in-form__for-employers-action"
          :to="{ name: 'auth-employer' }"
        >
          {{ $tAuth('continue_as_employer') }}
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import {EMPLOYEE, PARTNER} from '@/constants/usersTypes'
  import formMixins from '../../mixins/formMixins'
  import respondOnAllBooked from '@/actions/respondOnAllBooked'
  import respondOnVacancy from '@/actions/respondOnVacancy'
  // import AuthSocials from '../AuthSocials'
  import SignInFormTimer from './SignInFormTimer'
  import {VueReCaptcha} from 'vue-recaptcha-v3'
  import {getReferrers} from '@/services/referrers'

  Vue.use(VueReCaptcha, {
    siteKey: '6Lcd5ukZAAAAALK_vHlDJuPXEPkgLPZ0cGGHoulS',
    loaderOptions: {}
  })

  export default {
    name: 'SignInForm',
    mixins: [formMixins],
    components: {
      // AuthSocials,
      SignInFormTimer
    },
    props: {
      previousPage: [Object, String],
      isPartner: {
        type: Boolean,
        default: false
      },
      startUserType: Number
    },
    data() {
      return {
        timerDurationS: 60,
        pendingSendPhone: false,
        pendingLogin: false,
        pendingLoginByToken: false,
        errorStatusCode: null,
        inputs: {
          user_type: {
            value: EMPLOYEE,
            error: null
          },
          phone: {
            value: null,
            error: null
          },
          code: {
            value: null,
            error: null
          }
        },
        agree: false,
        shouldAutoSendPhone: false,
        isSent: false,
        showTimer: false,
        sentCode: false,
        message: null,
        recaptchaToken: null,
        isRegister: false,

        phoneValidation: null
      }
    },
    computed: {
      isPhoneCompleted() {
        return this.phoneValidation && this.phoneValidation.isValid
      },
      isPhoneSuccessButtonActive() {
        return this.isPhoneCompleted
          && (!this.isSent || !this.showTimer)
      },
      isLoginButtonActive() {
        return this.inputs.code.value && this.inputs.code.value.length >= 6
      },
      partnerReferralCode() {
        return this.$route.query.partner_referral_code
      },
      referralCode() {
        return this.$route.query.referal_code || getReferralFromLocalstorage()
      },
      isForCredit() {
        return this.$route.query['for-credit'] === 'true'
      },
      isForMassSent() {
        return this.$route.query['for-mass-sent'] === 'true'
      },
      isForRespond() {
        return !!this.$route.query['for-respond']
      },
      isForLegal() {
        return !!this.$route.query['for-legal']
      },
      isForBookmarksPage() {
        return this.$route.query['for-bookmarks-page'] === 'true'
          || (this.$route.query.redirect || '').includes('for-bookmarks-page=true')
      }
    },
    mounted() {
      this.sendPhoneOnPageLoad();
    },
    methods: {
      ...mapActions('user', [
        'getLoginConfirmationCode',
        'loginByPhoneAndCode',
        'loginByToken',
      ]),
      sendPhoneOnPageLoad() {
        const { phone } = this.$route.query;
        if (phone) {
          this.inputs.phone.value = phone;
          this.onAgreeChange(true);
          this.sendPhone();
        }
      },
      sendPhone() {
        this.message = null
        this.resetErrorsMix(this.inputs)

        if (!this.agree) {
          this.overallErrorsMix = this.$tAuth('Please agree rules')
          this.shouldAutoSendPhone = true
          return
        }

        const sendData = this.createSendDataMix(this.inputs)
        sendData.force = this.sentCode
        this.pendingSendPhone = true

        this.getLoginConfirmationCode({
          sendData,
          recaptchaToken: this.recaptchaToken
        }).then(({data}) => {
          this.isSent = true

          if (data.status === 'NOT_NEED_SEND') {
            this.showTimer = false
            this.message = data.message
            this.sentCode = true
          } else {
            this.showTimer = true
          }

          this.isRegister = data.action === 'register'
        }).catch((error => {
          this.errorHandlerMix(error)
        })).finally(() => {
          this.pendingSendPhone = false
        })
      },
      onLogin() {
        this.message = null
        this.resetErrorsMix(this.inputs)
        this.pendingLogin = true

        const sendData = this.createSendDataMix(this.inputs)

        if (this.isPartner) {
          sendData.partner_referal_code = this.partnerReferralCode
        } else {
          sendData.referal_code = this.referralCode
        }

        const referrersData = getReferrers()
        sendData['ad_referrer'] = referrersData.adReferrer || referrersData.comeFrom
        sendData['utm'] = referrersData.utm || null

        this.loginByPhoneAndCode({
          sendData,
          remember: true,
          recaptchaToken: this.recaptchaToken
        }).then(() => {
          return this.afterLogin()
        }).catch(e => {
          this.recaptchaRerun()

          this.errorHandlerMix(e)
        }).finally(() => {
          this.pendingLogin = false
        })
      },
      onAgreeChange(value) {
        this.agree = value

        if (value && this.shouldAutoSendPhone) {
          this.sendPhone()
        }

        this.onInput()
      },
      onInput(key) {
        this.shouldAutoSendPhone = false
        if (this.overallErrorsMix) {
          this.resetErrorsMix(this.inputs)
        }

        if (key === 'phone' && this.isSent) {
          this.isSent = false
          this.showTimer = false
        }
      },
      onTimerEnd() {
        this.showTimer = false
      },
      onClickRole(itemId) {
        this.inputs.user_type.value = itemId
      },
      afterLogin() {
        return this.$store.dispatch('user/loadUser').then(async (data) => {
          const userType = data.user.user_type
          const matchedRoute = this.$route.query.redirect ? this.$router.matcher.match(this.$route.query.redirect) : null

          if (!data.resumeCompleted) {
            return this.$router.push({ name: 'response-additional-questions' });
          }

          if (this.isForMassSent && userType === EMPLOYEE) {
            await respondOnAllBooked()
            if (matchedRoute && matchedRoute.name) {
              return this.$router.push({path: this.$route.query.redirect})
            } else {
              return this.$router.push({name: 'account-my-vacancies'})
            }
          } else if (this.isForRespond) {
            const vacancyId = parseFloat(this.$route.query['for-respond'])
            if (vacancyId) {
              await respondOnVacancy(vacancyId)
              if (matchedRoute && matchedRoute.name) {
                return this.$router.push({path: this.$route.query.redirect})
              } else {
                return this.$router.push({name: 'account-my-vacancies'})
              }
            }
          }

          if (
            matchedRoute
            && matchedRoute.name
          ) {
            if (
              !matchedRoute.meta.requiredUserTypes
              || !matchedRoute.meta.requiredUserTypes.length
              || matchedRoute.meta.requiredUserTypes.includes(userType)
            ) {
              return this.$router.push({path: this.$route.query.redirect})
            } else {
              const title = 'Для вашего аккаунта этот раздел закрыт'
              const message = userType === EMPLOYEE
                ? 'Вы авторизировались как соискатель. Для перехода в этот раздел вам нужно авторизировтся как роботодатель.'
                : 'Вы авторизировались как роботодатель. Для перехода в этот раздел вам нужно авторизировтся как соискатель.'
              this.$vModal.open('warning', {
                title,
                message
              })
            }
          }

          // if (this.previousPage && (this.previousPage.name !== 'home' && this.previousPage.name !== 'home-double')) {
          //   this.$router.push(this.previousPage.fullPath)
          // } else {
          if (data.user.user_type === EMPLOYEE) {
            this.openChatBotPrimary()
            this.$router.push({name: 'vacancies'})
          } else if (data.user.user_type === PARTNER) {
            this.$router.push({name: 'account-partner-partners-network'})
          } else {
            this.$router.push({name: 'account-vacancies'})
          }
        })
      },
      openChatBotPrimary() {
        if (!this.$store.state.user.resume && this.referralCode) {
          this.$vModal.open('after-respond-without-resume', {
            primary: true
          })
        }
      },
      onValidateTel(value) {
        this.phoneValidation = value
      },
      loginByTokenInner() {
        const token = this.$route.query.token
        if (!token) return

        this.pendingLoginByToken = true
        this.loginByToken({
          token,
        }).then(() => {
          this.afterLogin()
        }).catch(this.errorHandlerMix).finally(() => {
          this.pendingLoginByToken = false
        })
      },
      async recaptcha() {
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded()

        // Execute reCAPTCHA with action "login".
        this.recaptchaToken = await this.$recaptcha('login')
      },
      async recaptchaRerun() {
        this.recaptchaToken = await this.$recaptcha()
      },
    },
    created() {
      this.recaptcha()
      this.loginByTokenInner()

      if (this.referralCode) {
        setReferralToLocalstorage(this.referralCode)
      }

      if (this.startUserType) {
        this.inputs.user_type.value = this.startUserType
      }
    }
  }


  function setReferralToLocalstorage(code) {
    window.localStorage.setItem('referralCode', code)
  }

  function getReferralFromLocalstorage() {
    return window.localStorage.getItem('referralCode')
  }
</script>

<style lang="less">

</style>
